<template>
  <div class="d-flex">

    <div class="modal-wrapper d-flex flex-column">
      <BootstrapModal v-if="showSetup"
        id="manageProducts"
        class="modal"
        :disableButton="true"
        :remove-padding="true"
        :normal-modal="false"
        :remove-title="true"
        :remove-close-icon="true"
        :remove-overflow="true"
        :header-class="skeClass"

        portal-target="bootstrap-modal-header-product-setup"
        portal-target-close="bootstrap-modal-header-close-product-setup"

        @close="close"
      >
        <template #title> Product toevoegen </template>

        <div class="d-flex">
          <SetupStepsSidebar
            class="SetupStepsSidebar"
            :steps="steps"
            :remove-save-button="true"
            :css-display-styles="false"
            :is-editing="productId"
            :diselect-all="!!selectedWebsiteProduct"
            ignore-class="IGNORE-DEFAULT-SETUP-BEHAVIOR"
            query-selector="#components-wrapper"

            @save-form="editProduct"
            @click-on-section="selectedWebsiteProduct = null"
            @didnt-find-active-section="uid => selectedWebsiteProduct = uid"
            ref="steps"
          >
            <template #icon-basic-data>
              <svg
                width="16"
                height="16"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 14C11.0899 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1C3.91015 1 1 3.91015 1 7.5C1 11.0899 3.91015 14 7.5 14Z"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 5H10"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 7.5H10"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 10H10"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
            <template #icon-seo>
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
              </svg>
            </template>
            <template #icon-translations>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 48 48"
              >
                <g
                  transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
                >
                  <path
                    d="M4.5,12.5l-4,1,1-3v-9a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1Z"
                    style="
                      fill: none;
                      stroke: currentColor;
                      stroke-linecap: round;
                      stroke-linejoin: round;
                    "
                  ></path>
                </g>
              </svg>
            </template>
            <template #icon-numbers>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 48 48"
              >
                <g
                  transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
                >
                  <g>
                    <line
                      x1="0.5"
                      y1="13.5"
                      x2="9.5"
                      y2="4.5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <line
                      x1="11.5"
                      y1="2.5"
                      x2="12.5"
                      y2="1.5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <line
                      x1="9"
                      y1="2"
                      x2="9"
                      y2="0.5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <line
                      x1="12"
                      y1="5"
                      x2="13.5"
                      y2="5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <line
                      x1="11"
                      y1="7"
                      x2="12"
                      y2="8"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <line
                      x1="6"
                      y1="2"
                      x2="7"
                      y2="3"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                  </g>
                </g>
              </svg>
            </template>
            <template #icon-product-options>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 48 48"
              >
                <g
                  transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
                >
                  <g>
                    <rect
                      x="0.5"
                      y="1"
                      width="5"
                      height="5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></rect>
                    <line
                      x1="13.25"
                      y1="13.5"
                      x2="8.25"
                      y2="13.5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <line
                      x1="8.25"
                      y1="8.5"
                      x2="13.25"
                      y2="8.5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <line
                      x1="8.25"
                      y1="11"
                      x2="13.25"
                      y2="11"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></line>
                    <polygon
                      points="13.5 6 8 6 10.75 0.5 13.5 6"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></polygon>
                    <circle
                      cx="3"
                      cy="11"
                      r="2.5"
                      style="
                        fill: none;
                        stroke: currentColor;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                    ></circle>
                  </g>
                </g>
              </svg>
            </template>
            <template #icon-producten>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
              </svg>
            </template>
            <template #icon-user-mutations>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
                <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
                  <circle cx="5" cy="2.75" r="2.25" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></circle>
                  <path d="M3.5,12.5H.5V11A4.51,4.51,0,0,1,7,7" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                  <polygon points="13.5 8.5 8.79 13.21 6.66 13.5 6.96 11.37 11.66 6.66 13.5 8.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></polygon>
                </g></g>
              </svg>
            </template>
            <template #icon-orders>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
                <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
                  <path d="M12.36,6H1.64a1,1,0,0,0-1,1.13l.73,5.5a1,1,0,0,0,1,.87h9.24a1,1,0,0,0,1-.87l.73-5.5A1,1,0,0,0,12.36,6Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                  <line x1="4.5" y1="8.5" x2="4.5" y2="11" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <line x1="7" y1="8.5" x2="7" y2="11" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <line x1="9.5" y1="8.5" x2="9.5" y2="11" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <path d="M9.48,1.54A2.79,2.79,0,0,1,11.78,4L12,6" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                  <path d="M2,6l.22-2a2.79,2.79,0,0,1,2.3-2.44" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                  <path d="M9.5,1.75A1.25,1.25,0,0,1,8.25,3H5.75a1.25,1.25,0,0,1,0-2.5h2.5A1.25,1.25,0,0,1,9.5,1.75Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                </g></g>
              </svg>
            </template>
            <template #icon-product-bundle>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">

                <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
                  <line x1="7" y1="0.5" x2="7" y2="4.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <line x1="8.5" y1="11" x2="11" y2="11" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                  <path d="M.5,4.5h13a0,0,0,0,1,0,0v8a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-8A0,0,0,0,1,.5,4.5Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                  <path d="M.5,4.5,2,1.61A2,2,0,0,1,3.74.5h6.52a2,2,0,0,1,1.79,1.11L13.5,4.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                </g></g>
              </svg>
            </template>
            <template #icon-prices>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
                <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
                  <path d="M13.25,9.36,9.36,13.25a.75.75,0,0,1-1.06,0L1.79,6.74a.36.36,0,0,1-.11-.29l.59-3.84a.37.37,0,0,1,.34-.34l3.84-.59a.36.36,0,0,1,.29.11L13.25,8.3A.75.75,0,0,1,13.25,9.36Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
                  <line x1="4.03" y1="4.03" x2="0.53" y2="0.53" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
                </g></g>
              </svg>
            </template>

            <template v-if="productId" #below-sections>
              <div class="website-product-list">
                <h4 class="mt-10">
                  Website producten
                </h4>
                <ul v-if="isLoadingProductWebsites">
                  <li>
                    <span></span>
                  </li>
                  <li>
                    <span></span>
                  </li>
                  <li>
                    <span></span>
                  </li>
                  <li>
                    <span></span>
                  </li>
                  <li>
                    <span></span>
                  </li>
                  <li>
                    <span></span>
                  </li>
                </ul>
                <ul v-else-if="productWebsites.length">
                  <li v-for="(item, index) in productWebsites" :key="index"
                    class="website"
                    :class="{active: item.uid === selectedWebsiteProduct}"

                    @click="selectedWebsiteProduct = item.uid"
                  >
                    {{ item.domainname }}
                  </li>
                </ul>
                <div v-else class="website-products">
                  <!-- U heeft geen websiteproducten. -->
                  example.com
                </div>
              </div>
            </template>

            <template v-slot="{ active }">
              <div class="d-flex justify-content-between fields-wrapper">
                <div id="components-wrapper">
                  <BasicData
                    v-model="basicData"
                    :initialSource="initialSource"
                    :loadingHandler="!!(loadingHandler && productId)"

                    :initial-images="images"
                    :product-id="productId"
                    @set-images="val => images = val"
                    @upload-files="uploadFiles"
                    @delete-file="deleteFile"
                    @update-order="updateOrder"
                    :is-showing="!selectedWebsiteProduct"

                    :class="skeClass"
                    key="data"
                  />
                  <WebsiteSeo
                    v-model="seoData"
                    :initialSource="initialSource"
                    :product-id="productId"
                    :product-name="productName"
                    
                    :class="skeClass"
                    key="seo"
                  />
                  <!-- <NumbersStep
                    v-model="numbers"
                    :initialSource="initialSource"

                    :class="skeClass"
                    key="numbers"
                  /> -->
                  <ProductOptions
                    v-model="productOptions"
                    :initialSource="initialSource"
                    :checkmail="checkmail"
                    :class="skeClass"
                    key="product-options"
                  />
                  <div v-if="tooSmallForShowingSidebar" key="sidear-fields">
                    <SidebarFields
                      v-model="sidebarData"
                      :initialSource="initialSource"
                      :product-id="productId"
                      :skeClass="skeClass"
                      :full-page="true"
                      ref="sidebarfields"
                    />
                  </div>
                  <div v-if="productId" class="flex-grow-1 padding" key="product-id">
                    <AddProductToWebsiteTab
                      :product-id="productId"

                      @toggle-website="resetWebsiteProducten"
                    />
                  </div>
                  <div v-else class="flex-grow-1 padding" key="product-id-add">
                    <AddProductToWebsiteTab
                      v-model="websiteProductsUids"
                    />
                  </div>
                  <div v-if="productId" class="flex-grow-1 padding" key="translation">
                    <TranslationsManager
                      :auto-translate-endpoint="autoTranslateEndpoint"
                      empty-state-title="Dit product heeft geen vertalingen"
                      :productData="initialSource"

                      :endpoint="translationEndpoint"
                    />
                  </div>
                  <CustomerMutations v-if="productId"
                    :product-id="productId"
                  />
                  <ProductOrders v-if="productId"
                    :product-id="productId"
                    :is-active="active === 'orders'"
                  />
                  <BundleProducts v-if="productType === 'package'"
                    :bundleProducts="bundleProducts"
                    :productId="productId"
                    @set-products="v => bundleProducts = v"

                    key="product-bundle"
                  />

                  <div v-if="sidebarData.tier_price">
                      <div v-for="(tier, index) in tier_prices" :key="index" v-show="tier.state != 'removed'" class="tier_price_block">
                        <div class="remove_tier_block">
                          <svg class="delete-icon-tier" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 20 20" fill="red" @click="removeTierPrice(index)">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                          </svg>
                        </div>
                        <input
                          placeholder="from"
                          v-model="tier.from_qty"
                          type="number"
                          min="0"
                          :disabled="didIdComeFromProduct(tier.id)"
                        />
                        <span>/</span>
                        <input
                          placeholder="to"
                          v-model="tier.to_qty"
                          type="number"
                          min="0"
                          :disabled="didIdComeFromProduct(tier.id)"
                        />
                        <input
                          placeholder="price"
                          v-model="tier.price"
                          type="number"
                          class="ml-2"
                          min="0"
                          :disabled="didIdComeFromProduct(tier.id)"
                        />
                        <span v-if="(tier.to_qty && tier.from_qty ) && (Number(tier.to_qty) <= Number(tier.from_qty))" class="error_message">
                          Aan-waarde moet groter zijn dan Van-waarde
                        </span>
                      </div>
                      <div class="add_new_tier_block_button ml-4" @click="addTierPrice">
                        <svg width="18" height="18" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M23.5 47.9951C36.4787 47.9951 47 37.2511 47 23.9976C47 10.7441 36.4787 0 23.5 0C10.5213 0 0 10.7441 0 23.9976C0 37.2511 10.5213 47.9951 23.5 47.9951Z" fill="#007bff"/>
                          <path d="M23.5 12.9218V35.0734" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12.6538 23.9976H34.3461" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>Add New</span>
                      </div> 
                  </div>

                  <div v-if="selectedWebsiteProduct" class="IGNORE-DEFAULT-SETUP-BEHAVIOR website-product-fields padding">
                    <OverwriteProduct
                      :base-data="initialSource"
                      :is-showing="!!selectedWebsiteProduct"
                      :website-uid="selectedWebsiteProduct"
                      :product-id="productId"
                    />
                  </div>
                </div>

                <SidebarFields v-if="!tooSmallForShowingSidebar"
                  class="sidebar-fields"

                  v-model="sidebarData"
                  :initialSource="initialSource"
                  :product-id="productId"
                  :skeClass="skeClass"

                  ref="sidebarfields"
                />

                <!-- <span v-if="tooSmallForShowingSidebar"
                  class="sidebar-toggle"
                  :class="{isShowingRightSidebar, sidebarValidationError}"
                  @click="showSidebar = !showSidebar"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                  </svg>
                  <span class="ml-2">
                    Prices

                    <span v-if="sidebarValidationError">
                      <svg width="16" height="16" fill="none" stroke="var(--red)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    </span>
                  </span>
                </span> -->
              </div>
            </template>
          </SetupStepsSidebar>

          <template v-if="show">
            <portal
              to="bootstrap-modal-header-close-product-setup"
              class="d-flex align-items-center"
            >
              <div class="d-flex align-items-center" :class="skeClass">
                <button @click="close" class="go-back">
                  <i class="fa fa-angle-left"></i> <span>Terug</span>
                </button>

                <MultipleActionButton
                  :options="options"

                  @main-action="saveAndGoBack"
                >
                  Opslaan
                </MultipleActionButton>
              </div>
            </portal>
          </template>
        </div>

        <template #bootstrap-modal-header-top>
          <div class="d-flex align-items-center left-header-options" :class="skeClass">
            <FormInput
              class="mb-0 mr-2 product-name"
              v-model="$v.productName.$model"
              :vuelidate="$v"
              fieldName="productName"
              :ske="true"
              id="productName"
              placeholder="Productnaam"
            />

            <FormSelect
              v-model="productType"
              class="form-select"
              id="product-type"
              :ske="true"
              :options="productTypeOptions"
            />

            <FormCheckbox
              v-model="active"
              :inline="true"
              :green="true"
              :ske="true"
              id="active"
            >
              <span :style="active && 'color: var(--apple-green)'" style="font-weight: 600">
                Online
              </span>
            </FormCheckbox>

            <FormCheckbox
              :inline="true"
              :ske="true"
              id="featured"

              v-model="$v.featured.$model"
            >
              Uitgelichte artikel
            </FormCheckbox>

            <FormCheckbox
              :inline="true"
              :ske="true"
              id="mailbox"
              v-model="checkmail"
            >
              Fits in mailbox
            </FormCheckbox>
          </div>
        </template>
      </BootstrapModal>
    </div>
  </div>
</template>

<script>

import BootstrapModal from "../../layout/Modals/BootstrapModal.vue"
import SetupStepsSidebar from "../../layout/SetupStepsSidebar/SetupStepsSidebar.vue"

import FormInput from "../../components/Inputs/FormInput.vue"
import SidebarFields from "../../components/Product/NewProductModal/SidebarFields/SidebarFields.vue"
import RichText from "../../components/Inputs/FormRichText.vue"

import BasicData from "../../components/Product/NewProductModal/BasicData.vue"
import WebsiteSeo from "../../components/Product/NewProductModal/SidebarFields/WebsiteSeo.vue"
import TranslationStep from "../../components/Product/NewProductModal/SidebarFields/TranslationStep.vue"
import NumbersStep from "../../components/Product/NewProductModal/SidebarFields/NumbersStep.vue"
import ProductOptions from "../../components/Product/NewProductModal/SidebarFields/ProductOptions.vue"
import ProductOrders from "../../components/Product/NewProductModal/SidebarFields/ProductOrders.vue"
import TranslationsManager from "../../layout/TranslationsManager/TranslationsManager.vue"
import AddProductToWebsiteTab from "../../components/Product/AddProductToWebsiteTab.vue"
import CustomerMutations from "../../components/Product/CustomerMutations/CustomerMutations.vue"
import MultipleActionButton from "../../layout/MultipleActionButton.vue"
import BundleProducts from "./BundleProducts.vue"
import OverwriteProduct from "../../components/Product/OverwriteProduct.vue"

import FormCheckbox from "../../components/Inputs/FormCheckbox.vue"
import FormSelect from "../../components/Inputs/FormSelect.vue"
import CardTabs from "../../layout/CardTabs.vue"

import addedNewItemTableAlert from "../../mixins/addedNewItemTableAlert"
import fixDecimalCommaNotation from "../../mixins/fixDecimalCommaNotation"

import { required } from "vuelidate/lib/validators"

import transitionFunctionConstructor from "../../mixins/transitionFunctionConstructor"

export default {
  mixins: [addedNewItemTableAlert, fixDecimalCommaNotation(), transitionFunctionConstructor("widthEnter", "widthLeave", "width")],
  components: {
    WebsiteSeo,
    AddProductToWebsiteTab,
    BootstrapModal,
    MultipleActionButton,
    OverwriteProduct,
    TranslationsManager,
    FormCheckbox,
    SetupStepsSidebar,
    FormSelect,
    FormInput,
    SidebarFields,
    RichText,
    BasicData,
    ProductOptions,
    CardTabs,
    TranslationStep,
    NumbersStep,
    CustomerMutations,
    BundleProducts,
    ProductOrders
  },
  metaInfo: {
    title: "Nieuwe product",
  },
  validations: {
    productName: {required},
    product: {},
    featured: {},
  },
  data() {
    return {
      initialTierPrices: [],
      checkmail: false,
      show: false,
      productName: "",
      active: true,
      featured: false,
      loadedProduct: false,
      productType: "standard",
      showingSidebar: false,
      // showSidebar: false,
      // sidebarValidationError: false,
      tier_prices: [],
      initialSource: null,
      screenWidth: null,
      selectedWebsiteProduct: null,

      sidebarData: {},
      basicData: {},
      seoData: {},
      translationsData: {},
      numbers: {},
      productOptions: {},

      images: [],
      loadingHandler: true,
      showSetup: true,

      isLoadingProductWebsites: true,
      productWebsites: [],

      bundleProducts: [],
      websiteProductsUids: [],
      oldProducts: [],
    };
  },
  mounted() {
    this.show = true;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkViewport)
  },
  created() {
    this.loadProduct()
    this.loadImages()

    this.checkViewport()
    window.addEventListener("resize", this.checkViewport, {passive: true})
  },
  methods: {
    didIdComeFromProduct(id) {
      return this.initialTierPrices.some(item => item.id === id)
    },
    checkViewport() {
      this.screenWidth = window.screen.width
    },

    addTierPrice() {
      if(this.productId) {
        this.tier_prices.push({ from_qty: '', to_qty: '', price: '', state: 'added' });
      } else {
        this.tier_prices.push({ from_qty: '', to_qty: '', price: '' });
      }
    },

    removeTierPrice(index) {
      if(this.productId) {
        if(this.tier_prices[index].id) {
          let cloneTiers = [...this.tier_prices];
          cloneTiers[index].state = 'removed';
          this.tier_prices = cloneTiers;
        } else {
          let filteredTierPrices = this.tier_prices.filter((t, idx) => idx !== index)
          this.tier_prices = filteredTierPrices;
        }
        } else {
        let filteredTierPrices = this.tier_prices.filter((t, idx) => idx !== index)
        this.tier_prices = filteredTierPrices;
      }
    },

    async resetWebsiteProducten() {
      this.isLoadingProductWebsites = true
      this.loadWebsiteProducten(
        (await this.axios.get(`/api/products/${this.productId}`)).data
      )
      this.isLoadingProductWebsites = false
    },

    async loadWebsiteProducten({ websites }) {
      this.isLoadingProductWebsites = true

      this.productWebsites = await Promise.all(
        websites.map(async uid => {
          return (await this.axios.get(`/api/websites/${uid}`)).data
        })
      )

      this.isLoadingProductWebsites = false
    },
    async loadProduct() {
      const product = (await this.axios.get(`/api/products/${this.productId}`)).data
      this.initialTierPrices = product.tier_prices.map(item => ({ ...item }))

      if (this.productId) {
        this.loadWebsiteProducten(product)
      }

      this.initialSource = product
      this.loadedProduct = true
      this.active = product.active

      if (product.bundle_products && product.bundle_products.length) {
        this.productType = "package"
        this.bundleProducts = product.bundle_products
        this.oldProducts = this.bundleProducts.slice()
      }

      this.$v.productName.$model = product.name
      this.featured = product.featured
      if(product.width && product.height && product.depth) { 
        if(product.width <= 220 && product.height <= 8 && product.depth <= 220) {
          this.checkmail = true
        } else {
          this.checkmail = false
        }
      }
    },
    async updateOrder(fileIds) {
      const sku = this.productId
      this.$handlePromise(async () => {
        await Promise.all(
          fileIds.map(async (id, index) => {
            await this.axios.put(`/api/products/${sku}/files/${id}/sequence`, {
              sequence: index,
            })
          })
        )
        await this.loadImages()
      })
    },
    async loadImages() {
      this.loadingHandler = true

      const {results} = (await this.axios.get(`/api/products/${this.productId}/files`)).data
      results.sort((a, b) => a.sequence - b.sequence)
      this.images = results

      this.loadingHandler = false
    },

    close() {
      this.$router.go(-1)
    },
    async saveAndGoBack() {
      if (this.$refs.steps.goNext(false)) return;

      if (await this.editProduct()) this.$router.back()
    },
    async saveAndEdit() {
      const sku = await this.editProduct()
      if (sku) {
        this.$router.replace(`/admin/product/edit/${sku}`)
        setTimeout(() => {
          this.$router.go()
        }, 100)
      }
    },
    async saveAndAddNew() {
      if (await this.editProduct() && !this.productId) {
        this.initialSource = {}

        this.sidebarData = {}
        this.basicData = {}
        this.seoData = {}
        this.translationsData = {}
        this.numbers = {}
        this.productOptions = {}

        this.$v.productName.$model = ""
        this.active = true
        this.featured = false

        this.showSetup = false
        this.$nextTick(() => this.showSetup = true)
      }
    },
    async editProduct() {
      this.$v.$touch()
      if (this.$refs.steps.hasError() || this.$v.$error) return false

      const sidebarRef = this.$refs.sidebarfields
      const categories = (sidebarRef.product && sidebarRef.categoriesProduct && sidebarRef.categoriesProduct.categories.map(({ uid }) => uid))
      if (!categories.length) {
        this.$error("Selecteer ten minste één categorie!")
        return false
      }
      let isValid = true
      for(let i=0; i<this.tier_prices.length; i++){
        if(this.tier_prices[i].to_qty <= this.tier_prices[i].from_qty && this.tier_prices[i].state != 'removed'){
          isValid = false
          break
        }
      }
      if (!isValid) {
        this.$error("Aan-waarde moet groter zijn dan Van-waarde")
        return false
      }
      


      const basic = {...this.basicData}
      delete basic.images

      const sidebar = this.sidebarData
      delete sidebar.listOptions

      const tierPriceLength = this.tier_prices.length && this.tier_prices[0].from_qty && this.tier_prices[0].to_qty && this.tier_prices[0].price;

      const tier_prices = tierPriceLength ? this.tier_prices : [];

      const tierObj = {added: [], removed: []};

      if(this.productId) {
        for(let i = 0; i < tier_prices.length; i++) {
          if(tier_prices[i].state === 'removed') {
            tierObj.removed.push(tier_prices[i].id)
          } else if(tier_prices[i].state === 'added') {
            tierObj.added.push({from_qty: tier_prices[i].from_qty, to_qty: tier_prices[i].to_qty, price: tier_prices[i].price})
          }
        }
      }

      return await this.$handlePromise(async () => {
        let form = {
          name: this.$v.productName.$model,
          featured: this.$v.featured.$model,
          active: this.active,

          ...basic,
          ...sidebar,

          ...this.seoData,
          ...this.productOptions,
          categories,
        }
        form = {
          ...form,
          tier_prices: this.productId ? tierObj : tier_prices,
          recommended_retail_price: this.fixComma(form.recommended_retail_price),
          buy_price: this.fixComma(form.buy_price),
          product_stock: this.fixComma(form.product_stock),
          discount_percentage: this.fixComma(form.discount_percentage),

          width: this.fixComma(form.width),
          height: this.fixComma(form.height),
          depth: this.fixComma(form.depth),
          weight: this.fixComma(form.weight),

          special_price: this.fixComma(form.special_price),
          wholesale_price: this.fixComma(form.wholesale_price),
          wholesale_stock: this.fixComma(form.wholesale_stock),
        }
        const products = this.computedProducts
        if (products.length) {
          form.product_type = "BUNDLE"
          form.bundled_skus = products
        }

        const oldProducts = this.oldProducts
        if (this.productId) {
          const removed = oldProducts.filter(old => !products.some(item => item.sku === old.sku))
          const added = products.filter(item => !oldProducts.some(old => item.sku === old.sku))
          form.bundled_skus = {}
          if (removed.length) form.bundled_skus.removed = removed.map(item => item.sku)
          if (added.length) form.bundled_skus.added = added.map(item => ({qty: item.qty, sku: item.sku}))
        }

        if (!form.amount) delete form.amount

        let sku = false

        if (!this.productId) {
          const data = (await this.axios.post(
            "/api/products",
            form
          )).data
          this.saveForShowingOnTableLater("product", data)

          sku = data.sku

          await Promise.all([
            this.uploadImages(sku),
            this.assignWebsiteProducten(sku),
          ])
        } else {
          this.axios.put(
            `/api/products/${this.productId}`,
            form
          )
        }

        this.$success("Nieuw product succesvol toegevoegd!")
        return sku
      })
    },
    async assignWebsiteProducten(sku) {
      await Promise.all(
        this.websiteProductsUids.map(async uid => {
          await this.axios.put(`/api/websites/${uid}/products/${sku}`)
        })
      )
    },
    async uploadFiles(files) {
      await this.$handlePromise(
        Promise.all(files.map(async item => {
          const payload = new FormData()
          payload.append("filename", item.file)
          payload.append("type", "base")

          await this.axios.post(`/api/products/${this.productId}/files`, payload, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
        }))
      )

      this.$success("Nieuwe afbeelding toegevoegd")
      this.loadImages()
    },
    async deleteFile(filedId) {
      this.$handlePromise(async () => {
        await this.axios.delete(`/api/products/${this.productId}/files/${filedId}`)

        this.$success("Bestand succesvol verwijderen")
        this.loadImages()
      })
    },
    async uploadImages(sku) {
      this.images && await Promise.all(
        this.images.map(async ({ file }) => {
          const payload = new FormData()
          payload.append("filename", file)
          payload.append("type", "base")

          await this.axios.post(`/api/products/${sku}/files`, payload, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
        })
      )
    },
  },
  computed: {
    /* isShowingRightSidebar() {
      return !this.tooSmallForShowingSidebar || this.showSidebar
    }, */
    tooSmallForShowingSidebar() {
      return this.screenWidth < 1300
    },

    computedProducts() {
      return this.bundleProducts.map(item => ({
        sku: item.sku, qty: item.qty,
      }))
    },
    options() {
      const options = [
        {
          name: "Opslaan en teruggaan",
          action: this.saveAndGoBack,
        },
        {
          name: "Opslaan en nieuwe toevoegen",
          action: this.saveAndAddNew,
        },
      ]

      if (!this.product) {
        options.push({
          name: "Toevoegen en bewerken",
          action: this.saveAndEdit,
        })
      }

      return options
    },
    steps() {
      const steps = [
        {
          name: "Basic data",
          id: "basic-data",
        },
        {
          name: "SEO",
          id: "seo",
        },
        /* {
          name: "Numbers",
          id: "numbers",
        }, */
        {
          name: "Product options",
          id: "product-options",
        },
      ]

      if (this.tooSmallForShowingSidebar) {
        steps.push({
          name: "Prijzen",
          id: "prices",
        })
      }

      steps.push({
        name: "Website producten",
        id: "producten",
      })

      if (this.productId) {
        steps.push({
          name: "Translations",
          id: "translations",
        },
        {
          name: "Gebruikersmutaties",
          id: "user-mutations",
        },
        {
          name: "Bestellingen",
          id: "orders",
        })
      }

      if (this.productType !== "standard") {
        steps.push({
          name: "Product bundle",
          id: "product-bundle",
        })
      }

      if (this.sidebarData.tier_price) {
        steps.push({
          name: "Tier Price",
          id: "tier-price",
        })
      }

      return steps
    },

    autoTranslateEndpoint() {
      return `/api/products/${this.productId}/trigger-auto-translate`
    },
    translationEndpoint() {
      return `/api/products/${this.productId}/translations`
    },
    productId() {
      return this.$router.currentRoute.params.id
    },
    skeClass() {
      return (!this.productId || this.loadedProduct) ? "disable-ske" : ""
    },
    productTypeOptions() {
      return [
        {
          str: "Standaard product",
          value: "standard",
        },
        {
          str: "Product Pakket",
          value: "package",
        },
      ]
    },
  },
  watch: {
    selectedWebsiteProduct(val) {
      if (val) {
        this.$refs.steps.section = val
      }
    },
    /* tooSmallForShowingSidebar() {
      this.$refs.steps.updateSelectedComponentVisibility()
    }, */
    productType(val) {
      if (val === "standard") {
        this.bundleProducts = []
      }
    },
    'sidebarData.tier_price'(val){
      if(this.productId) {
        if(val) {
          this.tier_prices = this.initialSource.tier_prices
        } else {
          this.tier_prices = [];
        }
      } else {
        if(val) {
          this.tier_prices.push({ from_qty: '', to_qty: '', price: '' });
        } else {
          this.tier_prices = [];
        }
      }
    },
  },
}

</script>

<style scoped lang="scss">

@media (max-width: 1200px) {
  .left-header-options {
    flex-wrap: wrap;
    white-space: nowrap;
  }

  .left-header-options > div, .left-header-options > span {
    margin-top: 8px;
  }
}

@media (max-width: 6px) {
  .left-header-options .FormSelect {
    margin-left: 0px !important;
  }
}

.website-product-list {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-toggle {
  position: absolute;
  right: 0px;
  top: 0px;
  display: flex;
  align-items: center;
  margin-top: 4px;
  margin-right: 4px;
  display: inline-flex;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,.2);
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
  color: rgba(0,0,0,.8);
  transition-duration: .15s;
  z-index: 30;
  font-size: 15px;
}

/* .sidebarValidationError.sidebar-toggle {
  color: var(--red) !important;
  border: 1px solid var(--red);
} */

/* .sidebar-toggle svg {
  transform: rotate(0deg);
  transition-duration: .15s;
}

.sidebar-toggle:hover {
  background-color: rgb(250,250,250);
}

.sidebar-toggle.isShowingRightSidebar svg {
  transform: rotate(180deg);
}

.sidebar-fields.tooSmallForShowingSidebar {
  position: absolute;
  right: 0px;
  top: 0px;
  background-color: white;
  height: 100%;
  z-index: 20;
  box-shadow: -2px 0 8px rgba(0,0,0,.1);
  transform: translateX(100%);
  transition-duration: .15s;
}
 */
/* .sidebar-fields.tooSmallForShowingSidebar.isShowingRightSidebar {
  transform: translateX(0px);
} */

@media (min-width: 900px) {
  .product-name {
    width: 330px;
  }
}

.modal {
  flex-grow: 1;
  width: 100%;
}

.main-column {
  flex-basis: 100%;
}

.main-column {
  flex-basis: 100%;
}

.fields-wrapper {
  position: relative;
  flex-basis: 80%;
  width: 100%;
  overflow: hidden !important;
}

#components-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  flex-basis: 100%;
}

#components-wrapper > div {
  width: 100%;
  display: none;
}

.modal-wrapper {
  flex-basis: 80%;
}

@media (max-width: 1500px) {
  .fields-wrapper, .modal-wrapper {
    flex-basis: 100%;
  }
}


.form-select {
  margin: 0px;
  width: 225px;
}

.go-back {
  color: var(--black-70);
  padding: 10px;
  white-space: nowrap;
}

.website {
  margin-top: 3px;
  transition-duration: 0 !important;
}

.website-products {
  // text-align: center;
  margin-top: 12px;
  margin-bottom: 12px;
  color: rgba(0,0,0,.7);
  cursor: pointer;
  &:hover {
    color: #0081c7;
  }
}

h4 {
  margin-bottom: 0px;
}

.website-product-fields {
  z-index: 102;
  flex-basis: 100%;
  display: block !important;
  position: absolute;
  overflow: auto;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
  background-color: white;
}

.active {
  color: var(--mint-green) !important;
}


@media (max-width: 768px) {
  #manageProducts::v-deep {
    margin-left: 0;
    margin-right: 0;
    .modal-header {
      flex-direction: column-reverse;
      align-items: flex-start !important;

      > div {
        &:nth-child(1) {
          width: 100%;
          margin-top: 10px;
        }

        .form-group {
          width: 100%;
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
      }

      .left-header-options {
        flex-direction: column !important;
        align-items: start !important;
      }
    }
  }
}

.add_new_tier_block_button{
  cursor: pointer;
  margin-bottom: 13px;
  margin-top: 13px;
  display: flex;
  font-size: 15px;
  align-items: center;
}

.add_new_tier_block_button span {
  margin-left: 5px;
  color: #007bff;
}

.tier_price_block {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px 5px;
}

.tier_price_block input {
  width: 30%;
  border: 1px solid rgba(0, 0, 0, 0.125);
  text-indent: 5px;
  height: 30px;
}

.tier_price_block span {
  margin: 0 5px !important;
}

.tier_price_block p {
  margin-top: 5px;
  margin-bottom: 3px !important;
} 

.remove_tier_block {
  display: flex;
  justify-content: end;
}

.delete-icon-tier {
  cursor: pointer;
}

.error_message {
  color: red;
}
</style>
